import { theme } from '@fiverr-private/theme';
import { EnrichedTagsLayout, Nullable } from '../types';
import { getElementDimensions } from './general/getElementDimensions';

const getElementStyles = (tagsLayout: EnrichedTagsLayout): Partial<CSSStyleDeclaration> => ({
    fontSize: theme.typographyFontSizes[tagsLayout.fontSize],
    fontFamily: theme.fontFamily[tagsLayout.fontFamily],
    lineHeight: theme.bodyLineHeights[tagsLayout.lineHeight],
    paddingLeft: theme.spacing[tagsLayout.paddingX],
    paddingRight: theme.spacing[tagsLayout.paddingX],
    paddingTop: theme.spacing[tagsLayout.paddingY],
    paddingBottom: theme.spacing[tagsLayout.paddingY],
});

interface GetTagDimensionsProps {
    tagsLayout: EnrichedTagsLayout;
    label: string;
    icon?: Nullable<HTMLImageElement>;
    withGap?: boolean;
}

/**
 * Given a tag label and optional icon, returns the tag's dimensions as they would be rendered in the DOM.
 */
export const getTagDimensions = ({ tagsLayout, label, icon, withGap = true }: GetTagDimensionsProps) => {
    if (!label) {
        return { width: 0 };
    }

    const { width: textWidth } = getElementDimensions({
        content: label,
        elementStyles: getElementStyles(tagsLayout),
    });

    const iconWidth = icon ? icon.width + tagsLayout.gapSizePx : 0;
    const widthWithIcon = textWidth + iconWidth;

    const gapWidth = withGap ? tagsLayout.gapSizePx : 0;
    const widthWithGap = widthWithIcon + gapWidth;

    return { width: widthWithGap };
};
